import { render, staticRenderFns } from "./consultor-auto-complete-selecionado.vue?vue&type=template&id=6c53d1ca"
import script from "./consultor-auto-complete-selecionado.vue?vue&type=script&lang=ts"
export * from "./consultor-auto-complete-selecionado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports